import Cookies from 'js-cookie';

import Analytics from '@/scripts/old/helpers/Analytics';
import Unlockshare from '../Unlockshare';

function LandingB2C() {
  const self = this;

  self.init = function init(element) {
    const $wrap = $(element);

    if ($wrap.data('app-module-initialized')) return; // Prevent double init

    const $form = $wrap.find('.js-landing-b2c__form');
    const $share = $wrap.find('.js-landing-b2c__share');
    const $btns = $wrap.find('.js-landing-b2c__share-btn');
    const cookie = $wrap.data('landing-b2c-cookie');

    $btns.on('click', function onClick(e) {
      e.preventDefault();
      const $btn = $(this);
      const service = $btn.data('landing-b2c-share');

      if (!Unlockshare[service]) return;

      const data = {
        url: $btn.data('landing-b2c-share-url'),
        text: $btn.data('landing-b2c-share-text'),
      };

      switch (service) {
        case 'vk':
          Analytics.reachGoal('b2c_ShareVK', 'b2c_ShareVK');
          break;
        case 'fb':
          Analytics.reachGoal('b2c_ShareFB', 'b2c_ShareFB');
          break;
        case 'ok':
          Analytics.reachGoal('b2c_ShareOK', 'b2c_ShareOK');
          break;
        case 'tw':
          Analytics.reachGoal('b2c_ShareTW', 'b2c_ShareTW');
          break;
        default:
          break;
      }

      Unlockshare[service]((shared) => {
        if (!shared) return;

        $form.show();
        $share.hide();

        switch (service) {
          case 'vk':
            Analytics.reachGoal('b2c_ShareVKSuccess', 'b2c_ShareVKSuccess');
            break;
          case 'fb':
            Analytics.reachGoal('b2c_ShareFBSuccess', 'b2c_ShareFBSuccess');
            break;
          case 'ok':
            Analytics.reachGoal('b2c_ShareOKSuccess', 'b2c_ShareOKSuccess');
            break;
          case 'tw':
            Analytics.reachGoal('b2c_ShareTWSuccess', 'b2c_ShareTWSuccess');
            break;
          default:
            break;
        }

        Cookies.set(cookie, '1', { expires: 1 });
      }, data);
    });

    $wrap.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-landing-b2c').each(function init() {
      self.init(this);
    });
  };
}

export default new LandingB2C();
